<template>
  <div id="app" v-if="isReload">
    <router-view />
  </div>
</template>
<script>
import BootstrapMixin from './mixins/BootstrapMixin'
export default {
  mixins: [BootstrapMixin],
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      beforeUnloadTime: new Date().getTime(),
      isReload: true
    }
  },
  mounted() {
    //prevent double click or two fingers scale
    window.onload = function() {
      document.addEventListener('touchstart', function(event) {
        if (event.touches.length > 1) {
          event.preventDefault()
        }
      })
      var lastTouchEnd = 0
      document.addEventListener(
        'touchend',
        function(event) {
          var now = new Date().getTime()
          if (now - lastTouchEnd <= 300) {
            event.preventDefault()
          }
          lastTouchEnd = now
        },
        false
      )
      document.addEventListener('gesturestart', function(event) {
        event.preventDefault()
      })
    }

    // Before closing the page, clear the invitation code to prevent affecting the normal sign in flow
    window.addEventListener('beforeunload', () => this.beforeUnloadHandler())
    window.addEventListener('unload', () => this.unloadHandler())
  },
  methods: {
    beforeUnloadHandler() {
      this.beforeUnloadTime = new Date().getTime()
    },
    unloadHandler() {
      let gapTime = new Date().getTime() - this.beforeUnloadTime
      if (gapTime <= 5) {
        localStorage.removeItem('invitationCode')
      }
    },
    // reload whole page
    reload() {
      this.isReload = false
      this.$nextTick(() => {
        this.isReload = true
      })
    }
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', () => this.beforeUnloadHandler())
    window.removeEventListener('unload', () => this.unloadHandler())
  }
}
</script>
